import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "../store/auth.store";

export default function Logout() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const authStore = useAuthStore();
    useEffect(() => {
        if(authStore.jwt && document.location.pathname === '/logout') {
            authStore.logout(navigate);
            queryClient.invalidateQueries();
        }
    }, [navigate, authStore, queryClient]);

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            textAlign="center"
            px={2}
        >
            <LogoutIcon color="action" sx={{ fontSize: 60, mb: 2 }} />
            <Typography variant="h4" gutterBottom>
                You are logged out
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={4}>
                Thank you for using our service.
            </Typography>
            <Button variant="contained" onClick={() => navigate('/')}>
                Home
            </Button>
        </Box>
    );
}